var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, e) {
        return e.a = n, e.f = r, e;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(e) {
                return n(r, e);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(e) {
                return function(t) {
                    return n(r, e, t);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return n(r, e, t, a);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return n(r, e, t, a, u);
                        };
                    };
                };
            };
        });
    }
    function F6(n) {
        return r(6, n, function(r) {
            return function(e) {
                return function(t) {
                    return function(a) {
                        return function(u) {
                            return function(i) {
                                return n(r, e, t, a, u, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, e) {
        return 2 === n.a ? n.f(r, e) : n(r)(e);
    }
    function A3(n, r, e, t) {
        return 3 === n.a ? n.f(r, e, t) : n(r)(e)(t);
    }
    function A4(n, r, e, t, a) {
        return 4 === n.a ? n.f(r, e, t, a) : n(r)(e)(t)(a);
    }
    function A5(n, r, e, t, a, u) {
        return 5 === n.a ? n.f(r, e, t, a, u) : n(r)(e)(t)(a)(u);
    }
    function A6(n, r, e, t, a, u, i) {
        return 6 === n.a ? n.f(r, e, t, a, u, i) : n(r)(e)(t)(a)(u)(i);
    }
    var e = F3(function(n, r, e) {
        for(var t = Array(n), a = 0; n > a; a++)t[a] = e(r + a);
        return t;
    }), t = F2(function(n, r) {
        for(var e = Array(n), t = 0; n > t && r.b; t++)e[t] = r.a, r = r.b;
        return e.length = t, c(e, r);
    });
    function a(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    function u(n, r) {
        for(var e, t = [], a = i(n, r, 0, t); a && (e = t.pop()); a = i(e.a, e.b, 0, t));
        return a;
    }
    function i(n, r, e, t) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && a(5), !1;
        if (e > 100) return t.push(c(n, r)), !0;
        for(var u in 0 > n.$ && (n = Zr(n), r = Zr(r)), n)if (!i(n[u], r[u], e + 1, t)) return !1;
        return !0;
    }
    function o(n, r, e) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (e = o(n.a, r.a)) || (e = o(n.b, r.b)) ? e : o(n.c, r.c);
        for(; n.b && r.b && !(e = o(n.a, r.a)); n = n.b, r = r.b);
        return e || (n.b ? 1 : r.b ? -1 : 0);
    }
    var f = F2(function(n, r) {
        var e = o(n, r);
        return 0 > e ? Gr : e ? Xr : Vr;
    });
    function c(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function s(n, r, e) {
        return {
            a: n,
            b: r,
            c: e
        };
    }
    function v(n, r) {
        var e = {};
        for(var t in n)e[t] = n[t];
        for(var t in r)e[t] = r[t];
        return e;
    }
    function b(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var e = d(n.a, r);
        n = n.b;
        for(var t = e; n.b; n = n.b)t = t.b = d(n.a, r);
        return e;
    }
    var l = {
        $: 0
    };
    function d(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var g = F2(d);
    function h(n) {
        for(var r = l, e = n.length; e--;)r = d(n[e], r);
        return r;
    }
    var p = F3(function(n, r, e) {
        for(var t = []; r.b && e.b; r = r.b, e = e.b)t.push(A2(n, r.a, e.a));
        return h(t);
    }), m = Math.cos, T = Math.sin, A = Math.ceil, E = Math.floor, y = Math.sqrt, _ = Math.log;
    function $(n) {
        return {
            $: 2,
            b: n
        };
    }
    var R = $(function(n) {
        return "number" != typeof n ? P("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? Jr(n) : !isFinite(n) || n % 1 ? P("an INT", n) : Jr(n);
    }), S = ($(function(n) {
        return "boolean" == typeof n ? Jr(n) : P("a BOOL", n);
    }), $(function(n) {
        return "number" == typeof n ? Jr(n) : P("a FLOAT", n);
    })), F = ($(function(n) {
        return Jr(n);
    }), $(function(n) {
        return "string" == typeof n ? Jr(n) : n instanceof String ? Jr(n + "") : P("a STRING", n);
    })), L = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    function w(n, r) {
        return {
            $: 9,
            f: n,
            g: r
        };
    }
    var x = F2(function(n, r) {
        return {
            $: 10,
            b: r,
            h: n
        };
    }), C = F2(function(n, r) {
        return w(n, [
            r
        ]);
    }), O = F3(function(n, r, e) {
        return w(n, [
            r,
            e
        ]);
    }), B = F2(function(n, r) {
        return I(n, r);
    });
    function I(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? Jr(n.c) : P("null", r);
            case 3:
                return j(r) ? k(n.b, r, h) : P("a LIST", r);
            case 4:
                return j(r) ? k(n.b, r, N) : P("an ARRAY", r);
            case 6:
                var e = n.d;
                if ("object" != typeof r || null === r || !(e in r)) return P("an OBJECT with a field named `" + e + "`", r);
                var t = I(n.b, r[e]);
                return we(t) ? t : Kr(A2(Hr, e, t.a));
            case 7:
                var a = n.e;
                return j(r) ? r.length > a ? (t = I(n.b, r[a]), we(t) ? t : Kr(A2(Yr, a, t.a))) : P("a LONGER array. Need index " + a + " but only see " + r.length + " entries", r) : P("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || j(r)) return P("an OBJECT", r);
                var u = l;
                for(var i in r)if (Object.prototype.hasOwnProperty.call(r, i)) {
                    if (t = I(n.b, r[i]), !we(t)) return Kr(A2(Hr, i, t.a));
                    u = d(c(i, t.a), u);
                }
                return Jr(ce(u));
            case 9:
                for(var o = n.f, f = n.g, s = 0; f.length > s; s++){
                    if (t = I(f[s], r), !we(t)) return t;
                    o = o(t.a);
                }
                return Jr(o);
            case 10:
                return t = I(n.b, r), we(t) ? I(n.h(t.a), r) : t;
            case 11:
                for(var v = l, b = n.g; b.b; b = b.b){
                    if (t = I(b.a, r), we(t)) return t;
                    v = d(t.a, v);
                }
                return Kr(ne(ce(v)));
            case 1:
                return Kr(A2(Wr, n.a, r));
            case 0:
                return Jr(n.a);
        }
    }
    function k(n, r, e) {
        for(var t = r.length, a = Array(t), u = 0; t > u; u++){
            var i = I(n, r[u]);
            if (!we(i)) return Kr(A2(Yr, u, i.a));
            a[u] = i.a;
        }
        return Jr(e(a));
    }
    function j(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function N(n) {
        return A2(Le, n.length, function(r) {
            return n[r];
        });
    }
    function P(n, r) {
        return Kr(A2(Wr, "Expecting " + n, r));
    }
    function M(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return M(n.b, r.b);
            case 6:
                return n.d === r.d && M(n.b, r.b);
            case 7:
                return n.e === r.e && M(n.b, r.b);
            case 9:
                return n.f === r.f && D(n.g, r.g);
            case 10:
                return n.h === r.h && M(n.b, r.b);
            case 11:
                return D(n.g, r.g);
        }
    }
    function D(n, r) {
        var e = n.length;
        if (e !== r.length) return !1;
        for(var t = 0; e > t; t++)if (!M(n[t], r[t])) return !1;
        return !0;
    }
    function z(n) {
        return n;
    }
    function U(n) {
        return {
            $: 0,
            a: n
        };
    }
    function Q(n) {
        return {
            $: 1,
            a: n
        };
    }
    function q(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var Z = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), V = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), X = 0;
    function G(n) {
        var r = {
            $: 0,
            e: X++,
            f: n,
            g: null,
            h: []
        };
        return nn(r), r;
    }
    function K(n) {
        return q(function(r) {
            r(U(G(n)));
        });
    }
    function W(n, r) {
        n.h.push(r), nn(n);
    }
    var H = F2(function(n, r) {
        return q(function(e) {
            W(n, r), e(U(0));
        });
    }), Y = !1, J = [];
    function nn(n) {
        if (J.push(n), !Y) {
            for(Y = !0; n = J.shift();)rn(n);
            Y = !1;
        }
    }
    function rn(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, nn(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var en = {};
    function tn(n, r, e, t, a) {
        return {
            b: n,
            c: r,
            d: e,
            e: t,
            f: a
        };
    }
    function an(n, r) {
        var e = {
            g: r,
            h: void 0
        }, t = n.c, a = n.d, u = n.e, i = n.f;
        function o(n) {
            return A2(Z, o, {
                $: 5,
                b: function(r) {
                    var o = r.a;
                    return 0 === r.$ ? A3(a, e, o, n) : u && i ? A4(t, e, o.i, o.j, n) : A3(t, e, u ? o.i : o.j, n);
                }
            });
        }
        return e.h = G(A2(Z, o, n.b));
    }
    var un = F2(function(n, r) {
        return q(function(e) {
            n.g(r), e(U(0));
        });
    }), on = F2(function(n, r) {
        return A2(H, n.h, {
            $: 0,
            a: r
        });
    });
    function fn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function cn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var sn, vn = [], bn = !1;
    function ln(n, r, e) {
        if (vn.push({
            p: n,
            q: r,
            r: e
        }), !bn) {
            bn = !0;
            for(var t; t = vn.shift();)dn(t.p, t.q, t.r);
            bn = !1;
        }
    }
    function dn(n, r, e) {
        var t = {};
        for(var a in gn(!0, r, t, null), gn(!1, e, t, null), n)W(n[a], {
            $: "fx",
            a: t[a] || {
                i: l,
                j: l
            }
        });
    }
    function gn(n, r, e, t) {
        switch(r.$){
            case 1:
                var a = r.k, u = function(n, r, e, t) {
                    function a(n) {
                        for(var r = e; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? en[r].e : en[r].f, a, t);
                }(n, a, t, r.l);
                return void (e[a] = function(n, r, e) {
                    return e = e || {
                        i: l,
                        j: l
                    }, n ? e.i = d(r, e.i) : e.j = d(r, e.j), e;
                }(n, u, e[a]));
            case 2:
                for(var i = r.m; i.b; i = i.b)gn(n, i.a, e, t);
                return;
            case 3:
                return void gn(n, r.o, e, {
                    s: r.n,
                    t: t
                });
        }
    }
    var hn = "undefined" != typeof document ? document : {};
    function pn(n, r) {
        n.appendChild(r);
    }
    function mn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var Tn = F2(function(n, r) {
        return F2(function(e, t) {
            for(var a = [], u = 0; t.b; t = t.b){
                var i = t.a;
                u += i.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 1,
                c: r,
                d: _n(e),
                e: a,
                f: n,
                b: u
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(e, t) {
            for(var a = [], u = 0; t.b; t = t.b){
                var i = t.a;
                u += i.b.b || 0, a.push(i);
            }
            return u += a.length, {
                $: 2,
                c: r,
                d: _n(e),
                e: a,
                f: n,
                b: u
            };
        });
    })(void 0);
    var An, En = F2(function(n, r) {
        return {
            $: "a1",
            n: n,
            o: r
        };
    }), yn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function _n(n) {
        for(var r = {}; n.b; n = n.b){
            var e = n.a, t = e.$, a = e.n, u = e.o;
            if ("a2" !== t) {
                var i = r[t] || (r[t] = {});
                "a3" === t && "class" === a ? $n(i, a, u) : i[a] = u;
            } else "className" === a ? $n(r, a, z(u)) : r[a] = z(u);
        }
        return r;
    }
    function $n(n, r, e) {
        var t = n[r];
        n[r] = t ? t + " " + e : e;
    }
    function Rn(n, r) {
        var e = n.$;
        if (5 === e) return Rn(n.k || (n.k = n.m()), r);
        if (0 === e) return hn.createTextNode(n.a);
        if (4 === e) {
            for(var t = n.k, a = n.j; 4 === t.$;)"object" != typeof a ? a = [
                a,
                t.j
            ] : a.push(t.j), t = t.k;
            var u = {
                j: a,
                p: r
            };
            return (i = Rn(t, u)).elm_event_node_ref = u, i;
        }
        if (3 === e) return Sn(i = n.h(n.g), r, n.d), i;
        var i = n.f ? hn.createElementNS(n.f, n.c) : hn.createElement(n.c);
        sn && "a" == n.c && i.addEventListener("click", sn(i)), Sn(i, r, n.d);
        for(var o = n.e, f = 0; o.length > f; f++)pn(i, Rn(1 === e ? o[f] : o[f].b, r));
        return i;
    }
    function Sn(n, r, e) {
        for(var t in e){
            var a = e[t];
            "a1" === t ? Fn(n, a) : "a0" === t ? xn(n, r, a) : "a3" === t ? Ln(n, a) : "a4" === t ? wn(n, a) : ("value" !== t && "checked" !== t || n[t] !== a) && (n[t] = a);
        }
    }
    function Fn(n, r) {
        var e = n.style;
        for(var t in r)e[t] = r[t];
    }
    function Ln(n, r) {
        for(var e in r){
            var t = r[e];
            void 0 !== t ? n.setAttribute(e, t) : n.removeAttribute(e);
        }
    }
    function wn(n, r) {
        for(var e in r){
            var t = r[e], a = t.f, u = t.o;
            void 0 !== u ? n.setAttributeNS(a, e, u) : n.removeAttributeNS(a, e);
        }
    }
    function xn(n, r, e) {
        var t = n.elmFs || (n.elmFs = {});
        for(var a in e){
            var u = e[a], i = t[a];
            if (u) {
                if (i) {
                    if (i.q.$ === u.$) {
                        i.q = u;
                        continue;
                    }
                    n.removeEventListener(a, i);
                }
                i = Cn(r, u), n.addEventListener(a, i, An && {
                    passive: 2 > Be(u)
                }), t[a] = i;
            } else n.removeEventListener(a, i), t[a] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                An = !0;
            }
        }));
    } catch (n) {}
    function Cn(n, r) {
        function e(r) {
            var t = e.q, a = I(t.a, r);
            if (we(a)) {
                for(var u, i = Be(t), o = a.a, f = i ? 3 > i ? o.a : o.v : o, c = 1 == i ? o.b : 3 == i && o.az, s = (c && r.stopPropagation(), (2 == i ? o.b : 3 == i && o.at) && r.preventDefault(), n); u = s.j;){
                    if ("function" == typeof u) f = u(f);
                    else for(var v = u.length; v--;)f = u[v](f);
                    s = s.p;
                }
                s(f, c);
            }
        }
        return e.q = r, e;
    }
    function On(n, r) {
        return n.$ == r.$ && M(n.a, r.a);
    }
    function Bn(n, r, e, t) {
        var a = {
            $: r,
            r: e,
            s: t,
            t: void 0,
            u: void 0
        };
        return n.push(a), a;
    }
    function In(n, r, e, t) {
        if (n !== r) {
            var a = n.$, u = r.$;
            if (a !== u) {
                if (1 !== a || 2 !== u) return void Bn(e, 0, t, r);
                r = function(n) {
                    for(var r = n.e, e = r.length, t = Array(e), a = 0; e > a; a++)t[a] = r[a].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: t,
                        f: n.f,
                        b: n.b
                    };
                }(r), u = 1;
            }
            switch(u){
                case 5:
                    for(var i = n.l, o = r.l, f = i.length, c = f === o.length; c && f--;)c = i[f] === o[f];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var s = [];
                    return In(n.k, r.k, s, 0), void (s.length > 0 && Bn(e, 1, t, s));
                case 4:
                    for(var v = n.j, b = r.j, l = !1, d = n.k; 4 === d.$;)l = !0, "object" != typeof v ? v = [
                        v,
                        d.j
                    ] : v.push(d.j), d = d.k;
                    for(var g = r.k; 4 === g.$;)l = !0, "object" != typeof b ? b = [
                        b,
                        g.j
                    ] : b.push(g.j), g = g.k;
                    return l && v.length !== b.length ? void Bn(e, 0, t, r) : ((l ? function(n, r) {
                        for(var e = 0; n.length > e; e++)if (n[e] !== r[e]) return !1;
                        return !0;
                    }(v, b) : v === b) || Bn(e, 2, t, b), void In(d, g, e, t + 1));
                case 0:
                    return void (n.a !== r.a && Bn(e, 3, t, r.a));
                case 1:
                    return void kn(n, r, e, t, Nn);
                case 2:
                    return void kn(n, r, e, t, Pn);
                case 3:
                    if (n.h !== r.h) return void Bn(e, 0, t, r);
                    var h = jn(n.d, r.d);
                    h && Bn(e, 4, t, h);
                    var p = r.i(n.g, r.g);
                    return void (p && Bn(e, 5, t, p));
            }
        }
    }
    function kn(n, r, e, t, a) {
        if (n.c === r.c && n.f === r.f) {
            var u = jn(n.d, r.d);
            u && Bn(e, 4, t, u), a(n, r, e, t);
        } else Bn(e, 0, t, r);
    }
    function jn(n, r, e) {
        var t;
        for(var a in n)if ("a1" !== a && "a0" !== a && "a3" !== a && "a4" !== a) {
            if (a in r) {
                var u = n[a], i = r[a];
                u === i && "value" !== a && "checked" !== a || "a0" === e && On(u, i) || ((t = t || {})[a] = i);
            } else (t = t || {})[a] = e ? "a1" === e ? "" : "a0" === e || "a3" === e ? void 0 : {
                f: n[a].f,
                o: void 0
            } : "string" == typeof n[a] ? "" : null;
        } else {
            var o = jn(n[a], r[a] || {}, a);
            o && ((t = t || {})[a] = o);
        }
        for(var f in r)f in n || ((t = t || {})[f] = r[f]);
        return t;
    }
    function Nn(n, r, e, t) {
        var a = n.e, u = r.e, i = a.length, o = u.length;
        i > o ? Bn(e, 6, t, {
            v: o,
            i: i - o
        }) : o > i && Bn(e, 7, t, {
            v: i,
            e: u
        });
        for(var f = o > i ? i : o, c = 0; f > c; c++){
            var s = a[c];
            In(s, u[c], e, ++t), t += s.b || 0;
        }
    }
    function Pn(n, r, e, t) {
        for(var a = [], u = {}, i = [], o = n.e, f = r.e, c = o.length, s = f.length, v = 0, b = 0, l = t; c > v && s > b;){
            var d = (S = o[v]).a, g = (F = f[b]).a, h = S.b, p = F.b, m = void 0, T = void 0;
            if (d !== g) {
                var A = o[v + 1], E = f[b + 1];
                if (A) {
                    var y = A.a, _ = A.b;
                    T = g === y;
                }
                if (E) {
                    var $ = E.a, R = E.b;
                    m = d === $;
                }
                if (m && T) In(h, R, a, ++l), Dn(u, a, d, p, b, i), l += h.b || 0, zn(u, a, d, _, ++l), l += _.b || 0, v += 2, b += 2;
                else if (m) l++, Dn(u, a, g, p, b, i), In(h, R, a, l), l += h.b || 0, v += 1, b += 2;
                else if (T) zn(u, a, d, h, ++l), l += h.b || 0, In(_, p, a, ++l), l += _.b || 0, v += 2, b += 1;
                else {
                    if (!A || y !== $) break;
                    zn(u, a, d, h, ++l), Dn(u, a, g, p, b, i), l += h.b || 0, In(_, R, a, ++l), l += _.b || 0, v += 2, b += 2;
                }
            } else In(h, p, a, ++l), l += h.b || 0, v++, b++;
        }
        for(; c > v;){
            var S;
            l++, zn(u, a, (S = o[v]).a, h = S.b, l), l += h.b || 0, v++;
        }
        for(; s > b;){
            var F, L = L || [];
            Dn(u, a, (F = f[b]).a, F.b, void 0, L), b++;
        }
        (a.length > 0 || i.length > 0 || L) && Bn(e, 8, t, {
            w: a,
            x: i,
            y: L
        });
    }
    var Mn = "_elmW6BL";
    function Dn(n, r, e, t, a, u) {
        var i = n[e];
        if (!i) return u.push({
            r: a,
            A: i = {
                c: 0,
                z: t,
                r: a,
                s: void 0
            }
        }), void (n[e] = i);
        if (1 === i.c) {
            u.push({
                r: a,
                A: i
            }), i.c = 2;
            var o = [];
            return In(i.z, t, o, i.r), i.r = a, void (i.s.s = {
                w: o,
                A: i
            });
        }
        Dn(n, r, e + Mn, t, a, u);
    }
    function zn(n, r, e, t, a) {
        var u = n[e];
        if (u) {
            if (0 === u.c) {
                u.c = 2;
                var i = [];
                return In(t, u.z, i, a), void Bn(r, 9, a, {
                    w: i,
                    A: u
                });
            }
            zn(n, r, e + Mn, t, a);
        } else {
            var o = Bn(r, 9, a, void 0);
            n[e] = {
                c: 1,
                z: t,
                r: a,
                s: o
            };
        }
    }
    function Un(n, r, e, t) {
        Qn(n, r, e, 0, 0, r.b, t);
    }
    function Qn(n, r, e, t, a, u, i) {
        for(var o = e[t], f = o.r; f === a;){
            var c = o.$;
            if (1 === c) Un(n, r.k, o.s, i);
            else if (8 === c) o.t = n, o.u = i, (s = o.s.w).length > 0 && Qn(n, r, s, 0, a, u, i);
            else if (9 === c) {
                o.t = n, o.u = i;
                var s, v = o.s;
                v && (v.A.s = n, (s = v.w).length > 0 && Qn(n, r, s, 0, a, u, i));
            } else o.t = n, o.u = i;
            if (!(o = e[++t]) || (f = o.r) > u) return t;
        }
        var b = r.$;
        if (4 === b) {
            for(var l = r.k; 4 === l.$;)l = l.k;
            return Qn(n, l, e, t, a + 1, u, n.elm_event_node_ref);
        }
        for(var d = r.e, g = n.childNodes, h = 0; d.length > h; h++){
            a++;
            var p = 1 === b ? d[h] : d[h].b, m = a + (p.b || 0);
            if (!(a > f || f > m || (o = e[t = Qn(g[h], p, e, t, a, m, i)]) && (f = o.r) <= u)) return t;
            a = m;
        }
        return t;
    }
    function qn(n, r) {
        for(var e = 0; r.length > e; e++){
            var t = r[e], a = t.t, u = Zn(a, t);
            a === n && (n = u);
        }
        return n;
    }
    function Zn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, e) {
                    var t = n.parentNode, a = Rn(r, e);
                    return a.elm_event_node_ref || (a.elm_event_node_ref = n.elm_event_node_ref), t && a !== n && t.replaceChild(a, n), a;
                }(n, r.s, r.u);
            case 4:
                return Sn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return qn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var e = r.s, t = 0; e.i > t; t++)n.removeChild(n.childNodes[e.v]);
                return n;
            case 7:
                for(var u = (e = r.s).e, i = n.childNodes[t = e.v]; u.length > t; t++)n.insertBefore(Rn(u[t], r.u), i);
                return n;
            case 9:
                if (!(e = r.s)) return n.parentNode.removeChild(n), n;
                var o = e.A;
                return void 0 !== o.r && n.parentNode.removeChild(n), o.s = qn(n, e.w), n;
            case 8:
                return function(n, r) {
                    var e = r.s, t = function(n, r) {
                        if (n) {
                            for(var e = hn.createDocumentFragment(), t = 0; n.length > t; t++){
                                var a = n[t].A;
                                pn(e, 2 === a.c ? a.s : Rn(a.z, r.u));
                            }
                            return e;
                        }
                    }(e.y, r);
                    n = qn(n, e.w);
                    for(var a = e.x, u = 0; a.length > u; u++){
                        var i = a[u], o = i.A, f = 2 === o.c ? o.s : Rn(o.z, r.u);
                        n.insertBefore(f, n.childNodes[i.r]);
                    }
                    return t && pn(n, t), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                a(10);
        }
    }
    function Vn(n) {
        if (3 === n.nodeType) return mn(n.textContent);
        if (1 !== n.nodeType) return mn("");
        for(var r = l, e = n.attributes, t = e.length; t--;){
            var a = e[t];
            r = d(A2(yn, a.name, a.value), r);
        }
        var u = n.tagName.toLowerCase(), i = l, o = n.childNodes;
        for(t = o.length; t--;)i = d(Vn(o[t]), i);
        return A3(Tn, u, r, i);
    }
    var Xn = F4(function(n, r, e, t) {
        return function(n, r, e, t, u, i) {
            var o = A2(B, n, r ? r.flags : void 0);
            we(o) || a(2);
            var f = {}, c = e(o.a), s = c.a, v = i(l, s), b = function(n, r) {
                var e;
                for(var t in en){
                    var a = en[t];
                    a.a && ((e = e || {})[t] = a.a(t, r)), n[t] = an(a, r);
                }
                return e;
            }(f, l);
            function l(n, r) {
                var e = A2(t, n, s);
                v(s = e.a, r), ln(f, e.b, u(s));
            }
            return ln(f, c.b, u(s)), b ? {
                ports: b
            } : {};
        }(r, t, n.bn, n.bN, n.bK, function(r, e) {
            var t = n.ay && n.ay(r), a = n.bO, u = hn.title, i = hn.body, o = Vn(i);
            return function(n, r) {
                r(n);
                var e = 0;
                function t() {
                    e = 1 === e ? 0 : (Gn(t), r(n), 1);
                }
                return function(a, u) {
                    n = a, u ? (r(n), 2 === e && (e = 1)) : (0 === e && Gn(t), e = 2);
                };
            }(e, function(n) {
                sn = t;
                var e = a(n), f = Tn("body")(l)(e.be), c = function(n, r) {
                    var e = [];
                    return In(n, r, e, 0), e;
                }(o, f);
                i = function(n, r, e, t) {
                    return 0 === e.length ? n : (Un(n, r, e, t), qn(n, e));
                }(i, o, c, r), o = f, sn = 0, u !== e.bM && (hn.title = u = e.bM);
            });
        });
    }), Gn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    var Kn = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, Wn = "undefined" != typeof document ? document : Kn, Hn = "undefined" != typeof window ? window : Kn, Yn = F3(function(n, r, e) {
        return K(q(function() {
            function t(n) {
                G(e(n));
            }
            return n.addEventListener(r, t, An && {
                passive: !0
            }), function() {
                n.removeEventListener(r, t);
            };
        }));
    }), Jn = F2(function(n, r) {
        var e = I(n, r);
        return we(e) ? re(e.a) : ee;
    }), nr = F2(function(n, r) {
        var e = new Float64Array(2);
        return e[0] = n[0] + r[0], e[1] = n[1] + r[1], e;
    }), rr = F2(function(n, r) {
        var e = new Float64Array(2);
        return e[0] = n[0] - r[0], e[1] = n[1] - r[1], e;
    });
    var er = function(n) {
        return Math.sqrt(n[0] * n[0] + n[1] * n[1]);
    }, tr = F2(function(n, r) {
        var e = new Float64Array(2);
        return e[0] = r[0] * n, e[1] = r[1] * n, e;
    }), ar = F2(function(n, r) {
        return n[0] * r[0] + n[1] * r[1];
    }), ur = F3(function(n, r, e) {
        return new Float64Array([
            n,
            r,
            e
        ]);
    }), ir = F2(function(n, r) {
        var e = new Float64Array(3);
        return e[0] = n[0] + r[0], e[1] = n[1] + r[1], e[2] = n[2] + r[2], e;
    });
    var or = function(n) {
        return Math.sqrt(n[0] * n[0] + n[1] * n[1] + n[2] * n[2]);
    }, fr = F2(function(n, r) {
        return new Float64Array([
            r[0] * n,
            r[1] * n,
            r[2] * n
        ]);
    }), cr = F4(function(n, r, e, t) {
        return new Float64Array([
            n,
            r,
            e,
            t
        ]);
    }), sr = F6(function(n, r, e, t, a, u) {
        var i = 9728 !== r && 9729 !== r;
        return q(function(o) {
            var f = new Image;
            function c(u) {
                var o = u.createTexture();
                return u.bindTexture(u.TEXTURE_2D, o), u.pixelStorei(u.UNPACK_FLIP_Y_WEBGL, a), u.texImage2D(u.TEXTURE_2D, 0, u.RGBA, u.RGBA, u.UNSIGNED_BYTE, f), u.texParameteri(u.TEXTURE_2D, u.TEXTURE_MAG_FILTER, n), u.texParameteri(u.TEXTURE_2D, u.TEXTURE_MIN_FILTER, r), u.texParameteri(u.TEXTURE_2D, u.TEXTURE_WRAP_S, e), u.texParameteri(u.TEXTURE_2D, u.TEXTURE_WRAP_T, t), i && u.generateMipmap(u.TEXTURE_2D), u.bindTexture(u.TEXTURE_2D, null), o;
            }
            f.onload = function() {
                var n = f.width, r = f.height;
                o((n & n - 1 || r & r - 1) && (i || 33071 !== e || 33071 !== t) ? Q(A2(Tt, n, r)) : U({
                    $: 0,
                    bg: c,
                    a: n,
                    b: r
                }));
            }, f.onerror = function() {
                o(Q(mt));
            }, "data:" !== u.slice(0, 5) && (f.crossOrigin = "Anonymous"), f.src = u;
        });
    }), vr = F2(function(n, r) {
        return q(function() {
            var e = setInterval(function() {
                G(r);
            }, n);
            return function() {
                clearInterval(e);
            };
        });
    }), br = 0;
    function lr(n, r) {
        for(; r.b; r = r.b)n(r.a);
    }
    function dr(n) {
        for(var r = 0; n.b; n = n.b)r++;
        return r;
    }
    var gr = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        setTimeout(n, 1e3 / 60);
    }, hr = F5(function(n, r, e, t, a) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t,
            e: a
        };
    }), pr = F2(function(n, r) {
        var e = n.blend;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.BLEND), e.enabled = !0), e.a === r.a && e.d === r.d || (n.gl.blendEquationSeparate(r.a, r.d), e.a = r.a, e.d = r.d), e.b === r.b && e.c === r.c && e.e === r.e && e.f === r.f || (n.gl.blendFuncSeparate(r.b, r.c, r.e, r.f), e.b = r.b, e.c = r.c, e.e = r.e, e.f = r.f), e.g === r.g && e.h === r.h && e.i === r.i && e.j === r.j || (n.gl.blendColor(r.g, r.h, r.i, r.j), e.g = r.g, e.h = r.h, e.i = r.i, e.j = r.j);
    }), mr = F2(function(n, r) {
        var e = n.depthTest;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.DEPTH_TEST), e.enabled = !0), e.a !== r.a && (n.gl.depthFunc(r.a), e.a = r.a), e.b !== r.b && (n.gl.depthMask(r.b), e.b = r.b), e.c === r.c && e.d === r.d || (n.gl.depthRange(r.c, r.d), e.c = r.c, e.d = r.d);
    }), Tr = F2(function(n, r) {
        var e = n.stencilTest;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.STENCIL_TEST), e.enabled = !0), e.d === r.d && e.a === r.a && e.b === r.b || (n.gl.stencilFuncSeparate(n.gl.FRONT, r.d, r.a, r.b), e.d = r.d), e.e === r.e && e.f === r.f && e.g === r.g || (n.gl.stencilOpSeparate(n.gl.FRONT, r.e, r.f, r.g), e.e = r.e, e.f = r.f, e.g = r.g), e.c !== r.c && (n.gl.stencilMask(r.c), e.c = r.c), e.h === r.h && e.a === r.a && e.b === r.b || (n.gl.stencilFuncSeparate(n.gl.BACK, r.h, r.a, r.b), e.h = r.h, e.a = r.a, e.b = r.b), e.i === r.i && e.j === r.j && e.k === r.k || (n.gl.stencilOpSeparate(n.gl.BACK, r.i, r.j, r.k), e.i = r.i, e.j = r.j, e.k = r.k);
    }), Ar = F2(function(n, r) {
        var e = n.scissor;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.SCISSOR_TEST), e.enabled = !0), e.a === r.a && e.b === r.b && e.c === r.c && e.d === r.d || (n.gl.scissor(r.a, r.b, r.c, r.d), e.a = r.a, e.b = r.b, e.c = r.c, e.d = r.d);
    }), Er = F2(function(n, r) {
        var e = n.colorMask;
        e.toggle = n.toggle, e.enabled = !0, e.a === r.a && e.b === r.b && e.c === r.c && e.d === r.d || (n.gl.colorMask(r.a, r.b, r.c, r.d), e.a = r.a, e.b = r.b, e.c = r.c, e.d = r.d);
    }), yr = F2(function(n, r) {
        var e = n.cullFace;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.CULL_FACE), e.enabled = !0), e.a !== r.a && (n.gl.cullFace(r.a), e.a = r.a);
    }), _r = F2(function(n, r) {
        var e = n.polygonOffset;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.POLYGON_OFFSET_FILL), e.enabled = !0), e.a === r.a && e.b === r.b || (n.gl.polygonOffset(r.a, r.b), e.a = r.a, e.b = r.b);
    }), $r = F2(function(n, r) {
        var e = n.sampleCoverage;
        e.toggle = n.toggle, e.enabled || (n.gl.enable(n.gl.SAMPLE_COVERAGE), e.enabled = !0), e.a === r.a && e.b === r.b || (n.gl.sampleCoverage(r.a, r.b), e.a = r.a, e.b = r.b);
    }), Rr = function(n) {
        n.scissor.enabled && (n.gl.disable(n.gl.SCISSOR_TEST), n.scissor.enabled = !1);
    }, Sr = function(n) {
        var r = n.colorMask;
        r.a && r.b && r.c && r.d || (n.gl.colorMask(!0, !0, !0, !0), r.a = !0, r.b = !0, r.c = !0, r.d = !0);
    }, Fr = [
        "blend",
        "depthTest",
        "stencilTest",
        "scissor",
        "colorMask",
        "cullFace",
        "polygonOffset",
        "sampleCoverage",
        "sampleAlphaToCoverage"
    ], Lr = [
        function(n) {
            n.blend.enabled && (n.gl.disable(n.gl.BLEND), n.blend.enabled = !1);
        },
        function(n) {
            n.depthTest.enabled && (n.gl.disable(n.gl.DEPTH_TEST), n.depthTest.enabled = !1);
        },
        function(n) {
            n.stencilTest.enabled && (n.gl.disable(n.gl.STENCIL_TEST), n.stencilTest.enabled = !1);
        },
        Rr,
        Sr,
        function(n) {
            n.gl.disable(n.gl.CULL_FACE);
        },
        function(n) {
            n.gl.disable(n.gl.POLYGON_OFFSET_FILL);
        },
        function(n) {
            n.gl.disable(n.gl.SAMPLE_COVERAGE);
        },
        function(n) {
            n.gl.disable(n.gl.SAMPLE_ALPHA_TO_COVERAGE);
        }
    ];
    function wr(n, r, e) {
        var t = n.createShader(e);
        return n.shaderSource(t, "#extension GL_OES_standard_derivatives : enable\n" + r), n.compileShader(t), t;
    }
    function xr(n, r) {
        switch(r){
            case n.FLOAT:
                return {
                    size: 1,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_VEC2:
                return {
                    size: 2,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_VEC3:
                return {
                    size: 3,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_VEC4:
                return {
                    size: 4,
                    arraySize: 1,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.FLOAT_MAT4:
                return {
                    size: 4,
                    arraySize: 4,
                    type: Float32Array,
                    baseType: n.FLOAT
                };
            case n.INT:
                return {
                    size: 1,
                    arraySize: 1,
                    type: Int32Array,
                    baseType: n.INT
                };
        }
    }
    function Cr(n, r, e, t) {
        for(var a = e.a.aK, u = [], i = 0; a > i; i++)u.push(String.fromCharCode(97 + i));
        var o = xr(n, r.type);
        if (void 0 === o) throw Error("No info available for: " + r.type);
        var f = 0, c = o.size * o.arraySize * a, s = new o.type(dr(e.b) * c);
        lr(function(n) {
            !function(n, r, e, t, i) {
                var o;
                if (1 === a) for(o = 0; r > o; o++)n[e++] = 1 === r ? t[i] : t[i][o];
                else u.forEach(function(a) {
                    for(o = 0; r > o; o++)n[e++] = 1 === r ? t[a][i] : t[a][i][o];
                });
            }(s, o.size * o.arraySize, f, n, t[r.name] || r.name), f += c;
        }, e.b);
        var v = n.createBuffer();
        return n.bindBuffer(n.ARRAY_BUFFER, v), n.bufferData(n.ARRAY_BUFFER, s, n.STATIC_DRAW), v;
    }
    function Or(n, r) {
        return n + "#" + r;
    }
    var Br = F2(function(n, r) {
        var e = n.f, t = e.gl;
        return t ? (t.viewport(0, 0, t.drawingBufferWidth, t.drawingBufferHeight), e.depthTest.b || (t.depthMask(!0), e.depthTest.b = !0), e.stencilTest.c !== e.STENCIL_WRITEMASK && (t.stencilMask(e.STENCIL_WRITEMASK), e.stencilTest.c = e.STENCIL_WRITEMASK), Rr(e), Sr(e), t.clear(t.COLOR_BUFFER_BIT | t.DEPTH_BUFFER_BIT | t.STENCIL_BUFFER_BIT), lr(function(r) {
            if (r.d.b.b) {
                var a, u, i, o, f;
                if (r.b.id && r.c.id && (a = Or(r.b.id, r.c.id), u = e.programs[a]), !u) {
                    var c, s;
                    r.b.id ? c = e.shaders[r.b.id] : r.b.id = br++, c || (c = wr(t, r.b.src, t.VERTEX_SHADER), e.shaders[r.b.id] = c), r.c.id ? s = e.shaders[r.c.id] : r.c.id = br++, s || (s = wr(t, r.c.src, t.FRAGMENT_SHADER), e.shaders[r.c.id] = s);
                    var v = function(n, r, e) {
                        var t = n.createProgram();
                        if (n.attachShader(t, r), n.attachShader(t, e), n.linkProgram(t), !n.getProgramParameter(t, n.LINK_STATUS)) throw "Link failed: " + n.getProgramInfoLog(t) + "\nvs info-log: " + n.getShaderInfoLog(r) + "\nfs info-log: " + n.getShaderInfoLog(e);
                        return t;
                    }(t, c, s);
                    (u = {
                        glProgram: v,
                        attributes: Object.assign({}, r.b.attributes, r.c.attributes),
                        currentUniforms: {},
                        activeAttributes: [],
                        activeAttributeLocations: []
                    }).uniformSetters = function(n, r, e, t) {
                        var a = e.glProgram, u = e.currentUniforms, i = 0, o = r.f;
                        function f(r, e) {
                            var t = e.name, a = n.getUniformLocation(r, t);
                            switch(e.type){
                                case n.INT:
                                    return function(r) {
                                        u[t] !== r && (n.uniform1i(a, r), u[t] = r);
                                    };
                                case n.FLOAT:
                                    return function(r) {
                                        u[t] !== r && (n.uniform1f(a, r), u[t] = r);
                                    };
                                case n.FLOAT_VEC2:
                                    return function(r) {
                                        u[t] !== r && (n.uniform2f(a, r[0], r[1]), u[t] = r);
                                    };
                                case n.FLOAT_VEC3:
                                    return function(r) {
                                        u[t] !== r && (n.uniform3f(a, r[0], r[1], r[2]), u[t] = r);
                                    };
                                case n.FLOAT_VEC4:
                                    return function(r) {
                                        u[t] !== r && (n.uniform4f(a, r[0], r[1], r[2], r[3]), u[t] = r);
                                    };
                                case n.FLOAT_MAT4:
                                    return function(r) {
                                        u[t] !== r && (n.uniformMatrix4fv(a, !1, new Float32Array(r)), u[t] = r);
                                    };
                                case n.SAMPLER_2D:
                                    var f = i++;
                                    return function(r) {
                                        n.activeTexture(n.TEXTURE0 + f);
                                        var e = o.textures.get(r);
                                        e || (e = r.bg(n), o.textures.set(r, e)), n.bindTexture(n.TEXTURE_2D, e), u[t] !== r && (n.uniform1i(a, f), u[t] = r);
                                    };
                                case n.BOOL:
                                    return function(r) {
                                        u[t] !== r && (n.uniform1i(a, r), u[t] = r);
                                    };
                                default:
                                    return function() {};
                            }
                        }
                        for(var c = {}, s = n.getProgramParameter(a, n.ACTIVE_UNIFORMS), v = 0; s > v; v++){
                            var b = n.getActiveUniform(a, v);
                            c[t[b.name] || b.name] = f(a, b);
                        }
                        return c;
                    }(t, n, u, Object.assign({}, r.b.uniforms, r.c.uniforms));
                    var b = t.getProgramParameter(v, t.ACTIVE_ATTRIBUTES);
                    for(i = 0; b > i; i++){
                        var l = t.getActiveAttrib(v, i), d = t.getAttribLocation(v, l.name);
                        u.activeAttributes.push(l), u.activeAttributeLocations.push(d);
                    }
                    a = Or(r.b.id, r.c.id), e.programs[a] = u;
                }
                e.lastProgId !== a && (t.useProgram(u.glProgram), e.lastProgId = a), o = u.uniformSetters, Object.keys(f = r.e).forEach(function(n) {
                    var r = o[n];
                    r && r(f[n]);
                });
                var g = e.buffers.get(r.d);
                for(g || (g = function(n, r) {
                    if (r.a.aP > 0) {
                        var e = n.createBuffer(), t = function(n, r) {
                            var e, t = new Uint32Array(dr(n) * r), a = 0;
                            return lr(function(n) {
                                if (1 === r) t[a++] = n;
                                else for(e = 0; r > e; e++)t[a++] = n[String.fromCharCode(97 + e)];
                            }, n), t;
                        }(r.c, r.a.aP);
                        return n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, e), n.bufferData(n.ELEMENT_ARRAY_BUFFER, t, n.STATIC_DRAW), {
                            numIndices: t.length,
                            indexBuffer: e,
                            buffers: {}
                        };
                    }
                    return {
                        numIndices: r.a.aK * dr(r.b),
                        indexBuffer: null,
                        buffers: {}
                    };
                }(t, r.d), e.buffers.set(r.d, g)), i = 0; u.activeAttributes.length > i; i++){
                    d = u.activeAttributeLocations[i], void 0 === g.buffers[(l = u.activeAttributes[i]).name] && (g.buffers[l.name] = Cr(t, l, r.d, u.attributes)), t.bindBuffer(t.ARRAY_BUFFER, g.buffers[l.name]);
                    var h = xr(t, l.type);
                    if (1 === h.arraySize) t.enableVertexAttribArray(d), t.vertexAttribPointer(d, h.size, h.baseType, !1, 0, 0);
                    else for(var p = 4 * h.size, m = p * h.arraySize, T = 0; h.arraySize > T; T++)t.enableVertexAttribArray(d + T), t.vertexAttribPointer(d + T, h.size, h.baseType, !1, m, p * T);
                }
                for(e.toggle = !e.toggle, lr(ou(e), r.a), i = 0; 9 > i; i++){
                    var A = e[Fr[i]];
                    A.toggle !== e.toggle && A.enabled && (Lr[i](e), A.enabled = !1, A.toggle = e.toggle);
                }
                g.indexBuffer ? (t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, g.indexBuffer), t.drawElements(r.d.a.aS, g.numIndices, t.UNSIGNED_INT, 0)) : t.drawArrays(r.d.a.aS, 0, g.numIndices);
            }
        }, n.g), r) : r;
    }), Ir = F3(function(n, r, e) {
        return function(n, r, e, t) {
            return {
                $: 3,
                d: _n(n),
                g: r,
                h: e,
                i: t
            };
        }(r, {
            g: e,
            f: {},
            h: n
        }, zr, Ur);
    }), kr = F2(function(n, r) {
        n.contextAttributes.alpha = !0, n.contextAttributes.premultipliedAlpha = r.a;
    }), jr = F2(function(n, r) {
        n.contextAttributes.depth = !0, n.sceneSettings.push(function(n) {
            n.clearDepth(r.a);
        });
    }), Nr = F2(function(n, r) {
        n.contextAttributes.stencil = !0, n.sceneSettings.push(function(n) {
            n.clearStencil(r.a);
        });
    }), Pr = F2(function(n) {
        n.contextAttributes.antialias = !0;
    }), Mr = F2(function(n, r) {
        n.sceneSettings.push(function(n) {
            n.clearColor(r.a, r.b, r.c, r.d);
        });
    }), Dr = F2(function(n) {
        n.contextAttributes.preserveDrawingBuffer = !0;
    });
    function zr(n) {
        var r = {
            contextAttributes: {
                alpha: !1,
                depth: !1,
                stencil: !1,
                antialias: !1,
                premultipliedAlpha: !1,
                preserveDrawingBuffer: !1
            },
            sceneSettings: []
        };
        lr(function(n) {
            return A2(iu, r, n);
        }, n.h);
        var e = hn.createElement("canvas"), t = e.getContext && (e.getContext("webgl", r.contextAttributes) || e.getContext("experimental-webgl", r.contextAttributes));
        return t && "undefined" != typeof WeakMap ? (r.sceneSettings.forEach(function(n) {
            n(t);
        }), t.getExtension("OES_standard_derivatives"), t.getExtension("OES_element_index_uint"), n.f.gl = t, n.f.toggle = !1, n.f.blend = {
            enabled: !1,
            toggle: !1
        }, n.f.depthTest = {
            enabled: !1,
            toggle: !1
        }, n.f.stencilTest = {
            enabled: !1,
            toggle: !1
        }, n.f.scissor = {
            enabled: !1,
            toggle: !1
        }, n.f.colorMask = {
            enabled: !1,
            toggle: !1
        }, n.f.cullFace = {
            enabled: !1,
            toggle: !1
        }, n.f.polygonOffset = {
            enabled: !1,
            toggle: !1
        }, n.f.sampleCoverage = {
            enabled: !1,
            toggle: !1
        }, n.f.sampleAlphaToCoverage = {
            enabled: !1,
            toggle: !1
        }, n.f.shaders = [], n.f.programs = {}, n.f.lastProgId = null, n.f.buffers = new WeakMap, n.f.textures = new WeakMap, n.f.STENCIL_WRITEMASK = t.getParameter(t.STENCIL_WRITEMASK), gr(function() {
            return A2(Br, n, e);
        })) : (e = hn.createElement("div")).innerHTML = '<a href="https://get.webgl.org/">Enable WebGL</a> to see this content!', e;
    }
    function Ur(n, r) {
        return r.f = n.f, Br(r);
    }
    var Qr = g, qr = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.d, a = n, u = A3(n, e.b, e.c, A3(qr, n, r, e.e));
            n = a, r = u, e = t;
        }
    }), Zr = function(n) {
        return A3(qr, F3(function(n, r, e) {
            return A2(Qr, c(n, r), e);
        }), l, n);
    }, Vr = 1, Xr = 2, Gr = 0, Kr = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Wr = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Hr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Yr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), Jr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ne = function(n) {
        return {
            $: 2,
            a: n
        };
    }, re = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ee = {
        $: 1
    }, te = function(n) {
        return n + "";
    }, ae = F3(function(n, r, e) {
        for(;;){
            if (!e.b) return r;
            var t = e.b, a = n, u = A2(n, e.a, r);
            n = a, r = u, e = t;
        }
    }), ue = p, ie = F3(function(n, r, e) {
        for(;;){
            if (o(n, r) >= 1) return e;
            var t = n, a = r - 1, u = A2(Qr, r, e);
            n = t, r = a, e = u;
        }
    }), oe = F2(function(n, r) {
        return A3(ie, n, r, l);
    }), fe = F2(function(n, r) {
        return A3(ue, n, A2(oe, 0, function(n) {
            return A3(ae, F2(function(n, r) {
                return r + 1;
            }), 0, n);
        }(r) - 1), r);
    }), ce = function(n) {
        return A3(ae, Qr, l, n);
    }, se = 32, ve = F4(function(n, r, e, t) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), be = [], le = A, de = F2(function(n, r) {
        return _(r) / _(n);
    }), ge = le(A2(de, 2, se)), he = A4(ve, 0, ge, be, be), pe = e, me = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Te = E, Ae = function(n) {
        return n.length;
    }, Ee = F2(function(n, r) {
        return o(n, r) > 0 ? n : r;
    }), ye = function(n) {
        return {
            $: 0,
            a: n
        };
    }, _e = t, $e = F2(function(n, r) {
        for(;;){
            var e = A2(_e, se, n), t = e.b, a = A2(Qr, ye(e.a), r);
            if (!t.b) return ce(a);
            n = t, r = a;
        }
    }), Re = F2(function(n, r) {
        for(;;){
            var e = le(r / se);
            if (1 === e) return A2(_e, se, n).a;
            n = A2($e, n, l), r = e;
        }
    }), Se = F2(function(n, r) {
        if (r.b) {
            var e = r.b * se, t = Te(A2(de, se, e - 1)), a = n ? ce(r.e) : r.e, u = A2(Re, a, r.b);
            return A4(ve, Ae(r.d) + e, A2(Ee, 5, t * ge), u, r.d);
        }
        return A4(ve, Ae(r.d), ge, be, r.d);
    }), Fe = F5(function(n, r, e, t, a) {
        for(;;){
            if (0 > r) return A2(Se, !1, {
                e: t,
                b: e / se | 0,
                d: a
            });
            var u = me(A3(pe, se, r, n));
            r -= se, t = A2(Qr, u, t);
        }
    }), Le = F2(function(n, r) {
        if (n > 0) {
            var e = n % se;
            return A5(Fe, r, n - e - se, n, l, A3(pe, e, n - e, r));
        }
        return he;
    }), we = function(n) {
        return !n.$;
    }, xe = x, Ce = C, Oe = O, Be = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Ie = function(n) {
        return n;
    }, ke = U, je = ke(0), Ne = F4(function(n, r, e, t) {
        if (t.b) {
            var a = t.a, u = t.b;
            if (u.b) {
                var i = u.a, o = u.b;
                if (o.b) {
                    var f = o.a, c = o.b;
                    if (c.b) {
                        var s = c.b;
                        return A2(n, a, A2(n, i, A2(n, f, A2(n, c.a, e > 500 ? A3(ae, n, r, ce(s)) : A4(Ne, n, r, e + 1, s)))));
                    }
                    return A2(n, a, A2(n, i, A2(n, f, r)));
                }
                return A2(n, a, A2(n, i, r));
            }
            return A2(n, a, r);
        }
        return r;
    }), Pe = F3(function(n, r, e) {
        return A4(Ne, n, r, 0, e);
    }), Me = F2(function(n, r) {
        return A3(Pe, F2(function(r, e) {
            return A2(Qr, n(r), e);
        }), l, r);
    }), De = Z, ze = F2(function(n, r) {
        return A2(De, function(r) {
            return ke(n(r));
        }, r);
    }), Ue = F3(function(n, r, e) {
        return A2(De, function(r) {
            return A2(De, function(e) {
                return ke(A2(n, r, e));
            }, e);
        }, r);
    }), Qe = function(n) {
        return A3(Pe, Ue(Qr), ke(l), n);
    }, qe = un, Ze = F2(function(n, r) {
        var e = r;
        return K(A2(De, qe(n), e));
    }), Ve = F3(function(n, r) {
        return A2(ze, function() {
            return 0;
        }, Qe(A2(Me, Ze(n), r)));
    }), Xe = F3(function() {
        return ke(0);
    }), Ge = F2(function(n, r) {
        return A2(ze, n, r);
    });
    en.Task = tn(je, Ve, Xe, Ge);
    var Ke, We, He, Ye, Je = fn("Task"), nt = Xn, rt = L, et = F2(function(n, r) {
        return {
            $: 5,
            a: n,
            b: r
        };
    }), tt = F3(function(n, r, e) {
        return n(r(e));
    }), at = V, ut = F2(function(n, r) {
        return Je(A2(at, A2(tt, A2(tt, ke, n), Kr), A2(De, A2(tt, A2(tt, ke, n), Jr), r)));
    }), it = cn, ot = F2(function(n) {
        return n;
    }), ft = .0286, ct = F2(function(n, r) {
        return r.b ? A3(Pe, Qr, r, n) : n;
    }), st = F2(function(n, r) {
        return A3(Pe, ct, l, A2(Me, n, r));
    }), vt = function(n) {
        return new Float64Array([
            n.Q,
            n.R
        ]);
    }, bt = {
        f: 1,
        Q: 0,
        R: 0,
        g: 0
    }, lt = y, dt = ur, gt = (Ke = ft * lt(3), We = h([
        1,
        9,
        2,
        10,
        8,
        3,
        11,
        4,
        12,
        5,
        13,
        6,
        14,
        7,
        15
    ]), He = A2(st, function(n) {
        return A2(Me, function(r) {
            return vt({
                Q: .635 + n * Ke,
                R: .0572 * (r - n / 2)
            });
        }, A2(oe, 0, n));
    }, A2(oe, 0, 4)), A3(ue, F2(function(n, r) {
        return {
            af: n,
            aV: A3(dt, 0, 0, 0),
            aZ: r,
            a2: ft,
            a5: bt,
            a9: vt({
                Q: 0,
                R: 0
            })
        };
    }), We, He)), ht = {
        aF: .165,
        an: .2,
        ao: .2,
        _: 9.81,
        aR: 10,
        av: .95,
        aw: .65,
        ax: .015,
        ai: .05,
        bL: 1 / 240
    }, pt = F3(function(n, r, e) {
        var t = {
            af: 0,
            aV: A3(dt, 0, 0, 0),
            aZ: vt({
                Q: -0.635,
                R: 0
            }),
            a2: ft,
            a5: bt,
            a9: vt({
                Q: 0,
                R: 0
            })
        }, a = ht;
        return {
            D: 0,
            aE: ee,
            u: A2(Qr, t, gt),
            X: a,
            J: ee,
            B: {
                ap: 1.27,
                aB: 2.54
            },
            aA: A2(Me, ot(ee), n),
            al: e,
            am: r
        };
    }), mt = {
        $: 0
    }, Tt = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), At = F2(function(n, r) {
        var e = n.ad, t = n.ae, a = n.ac, u = n.ak, i = n.Y;
        return A4(F4(function(n, e, t, a) {
            return A6(sr, n, e, t, a, i, r);
        }), e, t, a, u);
    }), Et = {
        Y: !0,
        ac: 33071,
        ad: 9729,
        ae: 9728,
        ak: 33071
    }, yt = R, _t = F, $t = F2(function(n, r) {
        return {
            $: 4,
            a: n,
            b: r
        };
    }), Rt = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), St = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), Ft = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Lt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), wt = cn, xt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Ct = F2(function(n, r) {
        return {
            a$: r,
            a8: n
        };
    }), Ot = {
        $: -2
    }, Bt = Ot, It = ke(A2(Ct, Bt, Bt)), kt = f, jt = F2(function(n, r) {
        n: for(;;){
            if (-2 === r.$) return ee;
            var e = r.c, t = r.d, a = r.e;
            switch(A2(kt, n, r.b)){
                case 0:
                    r = t;
                    continue n;
                case 1:
                    return re(e);
                default:
                    r = a;
                    continue n;
            }
        }
    }), Nt = F5(function(n, r, e, t, a) {
        return {
            $: -1,
            a: n,
            b: r,
            c: e,
            d: t,
            e: a
        };
    }), Pt = F5(function(n, r, e, t, a) {
        if (-1 !== a.$ || a.a) {
            if (-1 !== t.$ || t.a || -1 !== t.d.$ || t.d.a) return A5(Nt, n, r, e, t, a);
            var u = t.d;
            return i = t.e, A5(Nt, 0, t.b, t.c, A5(Nt, 1, u.b, u.c, u.d, u.e), A5(Nt, 1, r, e, i, a));
        }
        var i, o = a.b, f = a.c, c = a.d, s = a.e;
        return -1 !== t.$ || t.a ? A5(Nt, n, o, f, A5(Nt, 0, r, e, t, c), s) : A5(Nt, 0, r, e, A5(Nt, 1, t.b, t.c, t.d, i = t.e), A5(Nt, 1, o, f, c, s));
    }), Mt = F3(function(n, r, e) {
        if (-2 === e.$) return A5(Nt, 0, n, r, Ot, Ot);
        var t = e.a, a = e.b, u = e.c, i = e.d, o = e.e;
        switch(A2(kt, n, a)){
            case 0:
                return A5(Pt, t, a, u, A3(Mt, n, r, i), o);
            case 1:
                return A5(Nt, t, a, r, i, o);
            default:
                return A5(Pt, t, a, u, i, A3(Mt, n, r, o));
        }
    }), Dt = F3(function(n, r, e) {
        var t = A3(Mt, n, r, e);
        return -1 !== t.$ || t.a ? t : A5(Nt, 1, t.b, t.c, t.d, t.e);
    }), zt = F2(function(n, r) {
        var e = n.a, t = n.b, a = A2(jt, e, r);
        return A3(Dt, e, 1 === a.$ ? h([
            t
        ]) : A2(Qr, t, a.a), r);
    }), Ut = function(n) {
        return q(function(r) {
            var e = n.f;
            2 === e.$ && e.c && e.c(), n.f = null, r(U(0));
        });
    }, Qt = F3(function(n, r, e) {
        for(;;){
            if (-2 === e.$) return r;
            var t = e.e, a = n, u = A3(n, e.b, e.c, A3(Qt, n, r, e.d));
            n = a, r = u, e = t;
        }
    }), qt = F6(function(n, r, e, t, a, u) {
        var i = A3(Qt, F3(function(t, a, u) {
            n: for(;;){
                var i = u.a, f = u.b;
                if (i.b) {
                    var s = i.a, v = s.a, b = s.b, l = i.b;
                    if (0 > o(v, t)) {
                        u = c(l, A3(n, v, b, f));
                        continue n;
                    }
                    return o(v, t) > 0 ? c(i, A3(e, t, a, f)) : c(l, A4(r, v, b, a, f));
                }
                return c(i, A3(e, t, a, f));
            }
        }), c(Zr(t), u), a), f = i.a, s = i.b;
        return A3(ae, F2(function(r, e) {
            return A3(n, r.a, r.b, e);
        }), s, f);
    }), Zt = on, Vt = vr, Xt = K, Gt = F3(function(n, r, e) {
        if (r.b) {
            var t = r.a, a = r.b, u = Xt(A2(Vt, t, A2(Zt, n, t)));
            return A2(De, function(r) {
                return A3(Gt, n, a, A3(Dt, t, r, e));
            }, u);
        }
        return ke(e);
    }), Kt = F3(function(n, r, e) {
        var t = e.a$, a = F3(function(n, r, e) {
            var t = e.c;
            return s(e.a, e.b, A2(De, function() {
                return t;
            }, Ut(r)));
        }), u = A3(ae, zt, Bt, r), i = A6(qt, F3(function(n, r, e) {
            var t = e.b, a = e.c;
            return s(A2(Qr, n, e.a), t, a);
        }), F4(function(n, r, e, t) {
            var a = t.c;
            return s(t.a, A3(Dt, n, e, t.b), a);
        }), a, u, t, s(l, Bt, ke(0))), o = i.a, f = i.b;
        return A2(De, function(n) {
            return ke(A2(Ct, u, n));
        }, A2(De, function() {
            return A3(Gt, n, o, f);
        }, i.c));
    }), Wt = (Ye = Ie, q(function(n) {
        n(U(Ye(Date.now())));
    })), Ht = F3(function(n, r, e) {
        var t = A2(jt, r, e.a8);
        if (1 === t.$) return ke(e);
        var a = t.a;
        return A2(De, function() {
            return ke(e);
        }, A2(De, function(r) {
            return Qe(A2(Me, function(e) {
                return A2(qe, n, e(r));
            }, a));
        }, Wt));
    }), Yt = F2(function(n, r) {
        return A2(xt, r.a, A2(tt, n, r.b));
    });
    en.Time = tn(It, Kt, Ht, 0, Yt);
    var Jt = fn("Time"), na = F2(function(n, r) {
        return Jt(A2(xt, n, r));
    }), ra = S, ea = function(n) {
        return A3(Oe, n, A2(rt, "clientX", ra), A2(rt, "clientY", ra));
    }, ta = F3(function(n, r, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: e
        };
    }), aa = F2(function(n, r) {
        return {
            aX: r,
            a7: n
        };
    }), ua = ke(A2(aa, l, Bt)), ia = function(n) {
        return c(b(n.a ? "w_" : "d_", n.b), n);
    }, oa = function(n) {
        return A3(ae, F2(function(n, r) {
            return A3(Dt, n.a, n.b, r);
        }), Bt, n);
    }, fa = F2(function(n, r) {
        return {
            aM: r,
            aQ: n
        };
    }), ca = F3(function(n, r, e) {
        return A2(ze, function(n) {
            return c(r, n);
        }, A3(Yn, e.a ? Hn : Wn, e.b, function(e) {
            return A2(Zt, n, A2(fa, r, e));
        }));
    }), sa = F2(function(n, r) {
        return A3(Qt, Dt, r, n);
    }), va = F3(function(n, r, e) {
        var t = F3(function(r, e, t) {
            var a = t.c;
            return s(t.a, t.b, A2(Qr, A3(ca, n, r, e), a));
        }), a = F3(function(n, r, e) {
            var t = e.b, a = e.c;
            return s(A2(Qr, r, e.a), t, a);
        }), u = F4(function(n, r, e, t) {
            var a = t.c;
            return s(t.a, A3(Dt, n, r, t.b), a);
        }), i = A2(Me, ia, r), o = A6(qt, a, u, t, e.aX, oa(i), s(l, Bt, l)), f = o.b, c = o.c;
        return A2(De, function(n) {
            return ke(A2(aa, i, A2(sa, f, oa(n))));
        }, A2(De, function() {
            return Qe(c);
        }, Qe(A2(Me, Ut, o.a))));
    }), ba = F3(function(n, r, e) {
        var t = n(r);
        return t.$ ? e : A2(Qr, t.a, e);
    }), la = F2(function(n, r) {
        return A3(Pe, ba(n), l, r);
    }), da = F3(function(n, r, e) {
        var t = r.aQ, a = r.aM, i = A2(la, function(n) {
            var r = n.b.c;
            return u(n.a, t) ? A2(Jn, r, a) : ee;
        }, e.a7);
        return A2(De, function() {
            return ke(e);
        }, Qe(A2(Me, qe(n), i)));
    }), ga = F2(function(n, r) {
        return A3(ta, r.a, r.b, A2(Ce, n, r.c));
    });
    en["Browser.Events"] = tn(ua, va, da, 0, ga);
    var ha, pa, ma = fn("Browser.Events"), Ta = F3(function(n, r, e) {
        return ma(A3(ta, n, r, e));
    }), Aa = A2(Ta, 0, "mousedown"), Ea = A2(Ta, 0, "mousemove"), ya = A2(Ta, 0, "mouseup"), _a = F2(function(n, r) {
        return 0 > o(n, r) ? n : r;
    }), $a = nr, Ra = ir, Sa = function(n) {
        return n[0];
    }, Fa = function(n) {
        return n[0];
    }, La = function(n) {
        return n[1];
    }, wa = function(n) {
        return n[1];
    }, xa = er, Ca = or, Oa = m, Ba = T, Ia = F2(function(n, r) {
        var e, t = Ba(r / 2);
        return {
            f: Oa(r / 2),
            Q: Fa(n) * t,
            R: wa(n) * t,
            g: (e = n, e[2] * t)
        };
    }), ka = F2(function(n, r) {
        return {
            f: n.f * r.f - n.Q * r.Q - n.R * r.R - n.g * r.g,
            Q: n.f * r.Q + n.Q * r.f + n.R * r.g - n.g * r.R,
            R: n.f * r.R - n.Q * r.g + n.R * r.f + n.g * r.Q,
            g: n.f * r.g + n.Q * r.R - n.R * r.Q + n.g * r.f
        };
    }), ja = tr, Na = fr, Pa = rr, Ma = F3(function(n, r, e) {
        var t, a, u = xa(e.a9), i = e.a2, f = function(n) {
            var r = La(n), e = Sa(n);
            return A3(dt, -r / i, e / i, 0);
        }, s = A2(Pa, e.a9, A2(ja, i, vt({
            Q: wa(e.aV),
            R: -Fa(e.aV)
        }))), b = xa(s), l = r.ax * r._, d = r.ao * r._, g = 5 * d / (2 * i), h = function() {
            if (o(b, r.ai) > 0) {
                var t = A2(ja, 1 / b, s), a = A2(Ra, e.aV, A2(Na, g * n, A3(dt, -La(t), Sa(t), 0))), v = A2(Pa, h = A2(Pa, e.a9, A2(ja, d * n, t)), A2(ja, i, vt({
                    Q: wa(a),
                    R: -Fa(a)
                })));
                return o(xa(v), r.ai) > 0 ? c(h, a) : xa(h) > 0 ? c(h, f(h)) : c(vt({
                    Q: 0,
                    R: 0
                }), A3(dt, 0, 0, 0));
            }
            var h;
            return u > 0 ? 1 > o(u, l * n) ? c(vt({
                Q: 0,
                R: 0
            }), A3(dt, 0, 0, 0)) : c(h = A2(Pa, e.a9, A2(ja, l * n, A2(ja, 1 / u, e.a9))), f(h)) : c(vt({
                Q: 0,
                R: 0
            }), A3(dt, 0, 0, 0));
        }(), p = h.a, m = h.b, T = Ca(m), A = T > 0 ? (a = lt((t = A2(ka, A2(Ia, A2(Na, 1 / T, m), T * n), e.a5)).f * t.f + t.Q * t.Q + t.R * t.R + t.g * t.g)) > 0 ? {
            f: t.f / a,
            Q: t.Q / a,
            R: t.R / a,
            g: t.g / a
        } : bt : e.a5;
        return v(e, {
            aV: m,
            aZ: A2($a, e.aZ, A2(ja, n, p)),
            a5: A,
            a9: p
        });
    }), Da = ar, za = F3(function(n, r, e) {
        var t = r.a2 + e.a2, a = A2(Pa, e.aZ, r.aZ), u = xa(a);
        return function() {
            if (0 > o(u, t) && u > 0) {
                var i = A2(Pa, r.a9, e.a9), f = A2(ja, 1 / u, a), s = A2($a, r.aZ, A2(ja, -(t - u) / 2, f)), b = A2($a, e.aZ, A2(ja, (t - u) / 2, f)), l = A2(Da, i, f), d = function() {
                    if (l > 0) {
                        var t = (1 + n.av) / 2 * l;
                        return c(A2(Pa, r.a9, A2(ja, t, f)), A2($a, e.a9, A2(ja, t, f)));
                    }
                    return c(r.a9, e.a9);
                }(), g = d.b;
                return c(v(r, {
                    aZ: s,
                    a9: d.a
                }), v(e, {
                    aZ: b,
                    a9: g
                }));
            }
            return c(r, e);
        }();
    }), Ua = F2(function(n, r) {
        if (r.b) {
            if (r.b.b) {
                var e = r.a, t = r.b, a = A3(ae, F2(function(r, e) {
                    var t = e.b, a = A3(za, n, e.a, r);
                    return c(a.a, A2(Qr, a.b, t));
                }), c(e, l), t);
                return A2(Qr, a.a, A2(Ua, n, ce(a.b)));
            }
            return h([
                r.a
            ]);
        }
        return l;
    }), Qa = F3(function(n, r, e) {
        return 0 > o(e, n) ? n : o(e, r) > 0 ? r : e;
    }), qa = F3(function(n, r, e) {
        var t = La(e.aZ), a = Sa(e.aZ), u = La(e.a9), i = Sa(e.a9), f = n.an, s = -r.ap / 2 + e.a2, b = -r.aB / 2 + e.a2, l = r.ap / 2 - e.a2, d = r.aB / 2 - e.a2, g = 1 > o(t, s) && 0 > u || o(t, l) > -1 && u > 0, h = 1 > o(a, b) && 0 > i || o(a, d) > -1 && i > 0, p = n.aw, m = h && g ? c(-p * i * (1 - f), -p * u * (1 - f)) : h ? c(-p * i, u * (1 - f)) : g ? c(i * (1 - f), -p * u) : c(i, u), T = m.a, A = m.b;
        return v(e, {
            aZ: vt({
                Q: A3(Qa, b, d, a),
                R: A3(Qa, s, l, t)
            }),
            a9: vt({
                Q: T,
                R: A
            })
        });
    }), Za = F4(function(n, r, e, t) {
        var a = F2(function(n, e) {
            for(;;){
                if (0 >= n) return e;
                n -= 1, e = A2(Ua, r, e);
            }
        }), u = A2(Me, A2(Ma, n, r), t);
        return A2(a, 5, A2(Me, A2(qa, r, e), u));
    }), Va = F2(function(n, r) {
        return v(r, {
            u: A4(Za, n, r.X, r.B, r.u)
        });
    }), Xa = F2(function(n, r) {
        var e = r.X.bL;
        return A2(F2(function(n, r) {
            return o(n, e) > -1 ? A2(Xa, n - e, A2(Va, e, r)) : v(r, {
                D: n
            });
        }), n, r);
    }), Ga = F2(function(n, r) {
        var e = n.J;
        if (1 === e.$) return v(n, {
            J: re(r)
        });
        var t = A2(Xa, n.D + A2(_a, .1, (r - e.a) / 1e3), n);
        return v(n, {
            D: t.D,
            u: t.u,
            J: re(r)
        });
    }), Ka = it(l), Wa = function(n) {
        var r = n.am / n.al, e = 1.08 * (n.B.ap / 2 + .05), t = 1.08 * (n.B.aB / 2 + .05);
        return o(r, n.B.aB / n.B.ap) > -1 ? {
            aa: e,
            ab: e * r
        } : {
            aa: t / r,
            ab: t
        };
    }, Ha = F3(function(n, r, e) {
        var t = Wa(n);
        return vt({
            Q: (r / n.am * 2 - 1) * t.ab,
            R: (1 - e / n.al * 2) * t.aa
        });
    }), Ya = F2(function(n, r) {
        for(;;){
            if (!r.b) return !1;
            var e = r.b;
            if (n(r.a)) return !0;
            r = e;
        }
    }), Ja = function(n) {
        return !n;
    }, nu = F2(function(n, r) {
        return !A2(Ya, A2(tt, Ja, n), r);
    }), ru = F2(function(n, r) {
        switch(n.$){
            case 0:
                var e = v(A = r.a, {
                    al: n.b,
                    am: n.a
                });
                return c(v(r, {
                    a: e
                }), Ka);
            case 1:
                return c(v(r, {
                    a: A2(Ga, r.a, n.a)
                }), Ka);
            case 2:
                var t = n.a, a = n.b;
                if (function(n) {
                    return A2(nu, function(n) {
                        return !xa(n.a9) && !Ca(n.aV);
                    }, n.u);
                }(r.a)) {
                    var i = v(A = r.a, {
                        aE: re({
                            bh: o = A3(Ha, A, t, a),
                            bJ: o
                        })
                    });
                    return c(v(r, {
                        a: i
                    }), Ka);
                }
                return c(r, Ka);
            case 3:
                t = n.a, a = n.b;
                var o, f = r.a.aE;
                return f.$ ? c(r, Ka) : (i = v(A = r.a, {
                    aE: re(v(b = f.a, {
                        bh: o = A3(Ha, A, t, a)
                    }))
                }), c(v(r, {
                    a: i
                }), Ka));
            case 4:
                var s = r.a.aE;
                if (s.$) return c(r, Ka);
                var b, l = r.a.X.aR, d = A2(Pa, (b = s.a).bJ, b.bh), g = xa(d), h = A2(_a, 5 * g, l), p = h > .05 ? A2(Me, function(n) {
                    return n.af ? n : v(n, {
                        a9: A2(ja, h / g, d)
                    });
                }, r.a.u) : r.a.u;
                return i = v(A = r.a, {
                    aE: ee,
                    u: p
                }), c(v(r, {
                    a: i
                }), Ka);
            default:
                var m = n.a, T = n.b, A = r.a, E = function() {
                    if (T.$) return A.aA;
                    var n = T.a;
                    return A2(fe, F2(function(r, e) {
                        return u(r, m) ? re(n) : e;
                    }), A.aA);
                }();
                return c(v(r, {
                    a: v(A, {
                        aA: E
                    })
                }), Ka);
        }
    }), eu = function(n) {
        return A2(yn, "height", te(n));
    }, tu = F6(function(n, r, e, t, a, u) {
        var i, o, f = r - n, c = t - e, s = u - a;
        return i = {
            bo: 2 / f,
            bp: 0,
            bq: 0,
            br: 0,
            bs: 0,
            bt: 2 / c,
            bu: 0,
            bv: 0,
            bw: 0,
            bx: 0,
            by: -2 / s,
            bz: 0,
            bA: -(r + n) / f,
            bB: -(t + e) / c,
            bC: -(u + a) / s,
            bD: 1
        }, (o = new Float64Array(16))[0] = i.bo, o[1] = i.bs, o[2] = i.bw, o[3] = i.bA, o[4] = i.bp, o[5] = i.bt, o[6] = i.bx, o[7] = i.bB, o[8] = i.bq, o[9] = i.bu, o[10] = i.by, o[11] = i.bC, o[12] = i.br, o[13] = i.bv, o[14] = i.bz, o[15] = i.bD, o;
    }), au = F2(function(n, r) {
        return {
            aH: r,
            aZ: n
        };
    }), uu = A4(F4(function(n, r, e, t) {
        return {
            $: 1,
            a: n,
            b: r,
            c: e,
            d: t
        };
    }), 513, {
        m: 1,
        n: 0,
        q: !0
    }.q, 0, 1), iu = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(kr, n, r);
            case 1:
                return A2(jr, n, r);
            case 2:
                return A2(Nr, n, r);
            case 3:
                return A2(Pr, n, r);
            case 4:
                return A2(Mr, n, r);
            default:
                return A2(Dr, n, r);
        }
    }), ou = F2(function(n, r) {
        switch(r.$){
            case 0:
                return A2(pr, n, r);
            case 1:
                return A2(mr, n, r);
            case 2:
                return A2(Tr, n, r);
            case 3:
                return A2(Ar, n, r);
            case 4:
                return A2(Er, n, r);
            case 5:
                return A2(yr, n, r);
            case 6:
                return A2(_r, n, r);
            case 7:
                return A2($r, n, r);
            default:
                return function(n) {
                    var r = n.sampleAlphaToCoverage;
                    r.toggle = n.toggle, r.enabled || (n.gl.enable(n.gl.SAMPLE_ALPHA_TO_COVERAGE), r.enabled = !0);
                }(n);
        }
    }), fu = hr(h([
        uu
    ])), cu = F2(function(n, r) {
        return A3(Pe, F2(function(r, e) {
            return n(r) ? A2(Qr, r, e) : e;
        }), l, r);
    }), su = function(n) {
        return n.b ? re(n.a) : ee;
    }, vu = {
        src: "\n        precision mediump float;\n        \n        varying vec3 vcolor;\n        varying vec3 vposition;\n        \n        void main () {\n            gl_FragColor = vec4(vcolor, 1.0);\n        }\n    ",
        attributes: {},
        uniforms: {}
    }, bu = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    })({
        aK: 3,
        aP: 0,
        aS: 4
    }), lu = {
        src: "\n        attribute vec3 position;\n        attribute vec3 color;\n        \n        uniform mat4 projection;\n        \n        varying vec3 vcolor;\n        varying vec3 vposition;\n        \n        void main () {\n            gl_Position = projection * vec4(position, 1.0);\n            vcolor = color;\n            vposition = position;\n        }\n    ",
        attributes: {
            color: "aH",
            position: "aZ"
        },
        uniforms: {
            projection: "ag"
        }
    }, du = F2(function(n, r) {
        var e = c(r.aE, function(n) {
            return su(A2(cu, function(n) {
                return !n.af;
            }, n.u));
        }(r));
        if (e.a.$ || e.b.$) return l;
        var t = e.a.a, a = e.b.a, u = A3(dt, 1, 1, 1), i = F3(function(n, r, e) {
            return s(A2(au, A3(dt, Sa(n), La(n), .5), u), A2(au, A3(dt, Sa(r), La(r), .5), u), A2(au, A3(dt, Sa(e), La(e), .5), u));
        }), o = a.aZ, f = A2(Pa, t.bJ, t.bh), v = xa(f), b = A2(ja, .004, vt({
            Q: -La(f),
            R: Sa(f)
        })), d = c(o, v > .001 ? A2($a, o, A2(ja, a.a2 + v, A2(ja, 1 / v, f))) : o), g = d.a, p = d.b, m = A2($a, g, b), T = A2(Pa, g, b), A = A2($a, p, b), E = A2(Pa, p, b), y = bu(h([
            A3(i, m, T, A),
            A3(i, T, E, A)
        ]));
        return h([
            A4(fu, lu, vu, y, {
                ag: n
            })
        ]);
    }), gu = F3(function(n, r, e) {
        return {
            aH: e,
            aI: r,
            aZ: n
        };
    }), hu = {
        src: "\n        precision mediump float;\n\n        varying vec3 vposition;\n        varying vec3 vdata;\n        varying vec3 vcolor;\n\n        void main () {\n            vec2 center = vdata.xy;\n            float radius = vdata.z;\n            vec2 diff = vposition.xy - center;\n            float dist = length(diff);\n\n            if (dist > radius) {\n                discard;\n            }\n\n            // Einfache Schattierung: heller in der Mitte\n            float shade = 0.5 + 0.5 * (1.0 - dist / radius);\n            gl_FragColor = vec4(vcolor * shade, 1.0);\n        }\n    ",
        attributes: {},
        uniforms: {}
    }, pu = {
        src: "\n        attribute vec3 position;\n        attribute vec3 data;\n        attribute vec3 color;\n\n        uniform mat4 projection;\n\n        varying vec3 vposition;\n        varying vec3 vdata;\n        varying vec3 vcolor;\n\n        void main () {\n            gl_Position = projection * vec4(position, 1.0);\n            vposition = position;\n            vdata = data;\n            vcolor = color;\n        }\n    ",
        attributes: {
            color: "aH",
            data: "aI",
            position: "aZ"
        },
        uniforms: {
            projection: "ag"
        }
    }, mu = F2(function(n, r) {
        var e = r.a2, t = r.aZ, a = Sa(t), u = La(t), i = A3(dt, a, u, e), o = function(n) {
            switch(n){
                case 0:
                default:
                    return A3(dt, .95, .95, .95);
                case 1:
                    return A3(dt, .9, .75, 0);
                case 2:
                    return A3(dt, 0, .25, .75);
                case 3:
                    return A3(dt, .8, .05, .05);
                case 4:
                    return A3(dt, .4, .1, .5);
                case 5:
                    return A3(dt, .95, .4, .05);
                case 6:
                    return A3(dt, 0, .4, .15);
                case 7:
                    return A3(dt, .55, .05, .05);
                case 8:
                    return A3(dt, .05, .05, .05);
            }
        }(r.af), f = h([
            s(A3(gu, A3(dt, a - e, u - e, 1), i, o), A3(gu, A3(dt, a + e, u - e, 1), i, o), A3(gu, A3(dt, a + e, u + e, 1), i, o)),
            s(A3(gu, A3(dt, a - e, u - e, 1), i, o), A3(gu, A3(dt, a + e, u + e, 1), i, o), A3(gu, A3(dt, a - e, u + e, 1), i, o))
        ]), c = bu(f);
        return A4(fu, pu, hu, c, {
            ag: n
        });
    }), Tu = F3(function(n, r, e) {
        return {
            aI: r,
            aZ: n,
            a5: e
        };
    }), Au = {
        src: '\n        precision mediump float;\n\n        uniform sampler2D ballTex;\n\n        varying vec3 vposition;\n        varying vec3 vdata;\n        varying vec4 vrot;\n\n        void main () {\n            vec2 center = vdata.xy;\n            float radius = vdata.z;\n\n            vec2 diff = vposition.xy - center;\n            float dist = length(diff);\n\n            if (dist > radius) {\n                discard;\n            }\n\n            // 3D-Richtung dieses Oberfl\xe4chenpunkts im Sicht-Rahmen\n            // (Top-Down: z zeigt zur Kamera, also "hoch" von der Platte)\n            vec3 P = vec3(\n                diff.x / radius,\n                diff.y / radius,\n                sqrt(max(0.0, 1.0 - (dist * dist) / (radius * radius)))\n            );\n\n            // Zur\xfcck in den K\xf6rper-Rahmen rotieren: inverse Rotation der\n            // Quaternion = Rotation mit der konjugierten (w, -qv).\n            // Vektorrotation ohne Matrix (transpose() existiert nicht in\n            // GLSL ES 1.00):  p\' = p + 2(qv \xd7 (qv \xd7 p)) \u2212 2w(qv \xd7 p)\n            vec3 qv = vrot.xyz;\n            vec3 b = P + 2.0 * cross(qv, cross(qv, P)) - 2.0 * vrot.w * cross(qv, P);\n\n            // Die Textur ist eine orthografische Sph\xe4ren-Map, zentriert auf\n            // +z des K\xf6rper-Rahmens ("Nordpol"): vordere Hemisph\xe4re direkt,\n            // hintere \xfcber den antipodalen Punkt (gespiegelt \u2013 echte Kugeln\n            // haben dort einen zweiten Nummernkreis).\n            vec2 uv = (b.z >= 0.0 ? b.xy : -b.xy) * 0.5 + 0.5;\n\n            vec4 tex = texture2D(ballTex, uv);\n\n            // Einfache Schattierung: heller in der Mitte (Sph\xe4ren-Look)\n            float shade = 0.5 + 0.5 * (1.0 - dist / radius);\n            gl_FragColor = vec4(tex.rgb * shade, 1.0);\n        }\n    ',
        attributes: {},
        uniforms: {
            ballTex: "bd"
        }
    }, Eu = {
        src: "\n        attribute vec3 position;\n        attribute vec3 data;\n        attribute vec4 rot;\n\n        uniform mat4 projection;\n\n        varying vec3 vposition;\n        varying vec3 vdata;\n        varying vec4 vrot;\n\n        void main () {\n            gl_Position = projection * vec4(position, 1.0);\n            vposition = position;\n            vdata = data;\n            vrot = rot;\n        }\n    ",
        attributes: {
            data: "aI",
            position: "aZ",
            rot: "a5"
        },
        uniforms: {
            projection: "ag"
        }
    }, yu = cr, _u = F3(function(n, r, e) {
        var t = La(e.aZ), a = Sa(e.aZ), u = A4(yu, e.a5.Q, e.a5.R, e.a5.g, e.a5.f), i = e.a2, o = A3(dt, a, t, i), f = h([
            s(A3(Tu, A3(dt, a - i, t - i, 1), o, u), A3(Tu, A3(dt, a + i, t - i, 1), o, u), A3(Tu, A3(dt, a + i, t + i, 1), o, u)),
            s(A3(Tu, A3(dt, a - i, t - i, 1), o, u), A3(Tu, A3(dt, a + i, t + i, 1), o, u), A3(Tu, A3(dt, a - i, t + i, 1), o, u))
        ]), c = bu(f);
        return A4(fu, Eu, Au, c, {
            bd: r,
            ag: n
        });
    }), $u = F3(function(n, r, e) {
        return r.$ ? A2(mu, n, e) : A3(_u, n, r.a, e);
    }), Ru = F2(function(n, r) {
        var e = r.aB / 2, t = r.ap / 2, a = A3(dt, .2, .7, .2), u = h([
            s(A2(au, A3(dt, -e, -t, 0), a), A2(au, A3(dt, e, -t, 0), a), A2(au, A3(dt, e, t, 0), a)),
            s(A2(au, A3(dt, -e, -t, 0), a), A2(au, A3(dt, e, t, 0), a), A2(au, A3(dt, -e, t, 0), a))
        ]), i = A3(dt, .6, .4, .2), o = .05, f = b(h([
            s(A2(au, A3(dt, -e - o, t, -0.1), i), A2(au, A3(dt, e + o, t, -0.1), i), A2(au, A3(dt, e + o, t + o, -0.1), i)),
            s(A2(au, A3(dt, -e - o, t, -0.1), i), A2(au, A3(dt, e + o, t + o, -0.1), i), A2(au, A3(dt, -e - o, t + o, -0.1), i)),
            s(A2(au, A3(dt, -e - o, -t - o, -0.1), i), A2(au, A3(dt, e + o, -t - o, -0.1), i), A2(au, A3(dt, e + o, -t, -0.1), i)),
            s(A2(au, A3(dt, -e - o, -t - o, -0.1), i), A2(au, A3(dt, e + o, -t, -0.1), i), A2(au, A3(dt, -e - o, -t, -0.1), i)),
            s(A2(au, A3(dt, -e - o, -t, -0.1), i), A2(au, A3(dt, -e, -t, -0.1), i), A2(au, A3(dt, -e, t, -0.1), i)),
            s(A2(au, A3(dt, -e - o, -t, -0.1), i), A2(au, A3(dt, -e, t, -0.1), i), A2(au, A3(dt, -e - o, t, -0.1), i)),
            s(A2(au, A3(dt, e, -t, -0.1), i), A2(au, A3(dt, e + o, -t, -0.1), i), A2(au, A3(dt, e + o, t, -0.1), i)),
            s(A2(au, A3(dt, e, -t, -0.1), i), A2(au, A3(dt, e + o, t, -0.1), i), A2(au, A3(dt, e, t, -0.1), i))
        ]), u), c = bu(f);
        return A4(fu, lu, vu, c, {
            ag: n
        });
    }), Su = F2(function(n, r) {
        return r.$ ? ee : n(r.a);
    }), Fu = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Lu = F2(function(n, r) {
        return A2(Su, Ie, su(A2(Fu, r.af, n.aA)));
    }), wu = En, xu = F3(function(n, r, e) {
        return A3(Ir, n, r, e);
    })(h([
        (pa = !0, {
            $: 0,
            a: pa
        }),
        {
            $: 3
        },
        function(n) {
            return {
                $: 1,
                a: n
            };
        }(1)
    ])), Cu = function(n) {
        var r, e, t, a, u = Te(n.am), i = Te(n.al);
        return A2(xu, h([
            (a = u, A2(yn, "width", te(a))),
            eu(i),
            A2(wu, "display", "block"),
            A2(wu, "position", "fixed"),
            A2(wu, "top", "0"),
            A2(wu, "left", "0"),
            A2(wu, "width", "100vw"),
            A2(wu, "height", "100vh")
        ]), (e = Wa(r = n), A2(Qr, A2(Ru, t = A6(tu, -e.ab, e.ab, -e.aa, e.aa, -1, 1), r.B), b(A2(Me, function(n) {
            return A3($u, t, A2(Lu, r, n), n);
        }, r.u), A2(du, t, r)))));
    };
    ha = {
        Main: {
            init: nt({
                bn: function(n) {
                    var r = A2(fe, F2(function(n, r) {
                        return A2(ut, et(n), function(n) {
                            return A2(At, Et, n);
                        }(r));
                    }), n.aj);
                    return c({
                        a: A3(pt, n.aj, n.am, n.al)
                    }, it(r));
                },
                bK: function() {
                    var n;
                    return wt(h([
                        (n = Lt, A3(Ta, 1, "resize", A2(rt, "target", A3(Oe, n, A2(rt, "innerWidth", yt), A2(rt, "innerHeight", yt))))),
                        A2(na, 16, Ft),
                        Aa(ea(St)),
                        Ea(ea(Rt)),
                        ya(ea($t))
                    ]));
                },
                bN: ru,
                bO: function(n) {
                    return {
                        be: h([
                            Cu(n.a)
                        ]),
                        bM: "Billard-Simulation"
                    };
                }
            })(A2(xe, function(n) {
                return A2(xe, function(r) {
                    return A2(xe, function(e) {
                        return {
                            $: 0,
                            a: {
                                aj: e,
                                al: r,
                                am: n
                            }
                        };
                    }, A2(rt, "textureUrls", {
                        $: 3,
                        b: _t
                    }));
                }, A2(rt, "windowHeight", yt));
            }, A2(rt, "windowWidth", yt)))(0)
        }
    }, n.Elm ? function n(r, e) {
        for(var t in e)t in r ? "init" == t ? a(6) : n(r[t], e[t]) : r[t] = e[t];
    }(n.Elm, ha) : n.Elm = ha;
}($a0b4f895e1596b3b$exports);


















// Im Production-Build sind die Default-Imports fertige URL-Strings.
// Im Dev-Build (CJS, weil Elm CJS kompiliert) liefert Parcel für Asset-Module
// leere Stubs – die echten (gehashten) URLs stehen dann im importmap des
// index.html. Deshalb: String nutzen, sonst aus dem importmap nachschlagen.
const $35da740d59af89ba$var$importedUrls = [
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {}),
    (0, {})
];
function $35da740d59af89ba$var$devTextureUrl(index) {
    const el = document.querySelector('script[type="importmap"]');
    if (!el) return null;
    try {
        const map = JSON.parse(el.textContent).imports || {};
        for (const url of Object.values(map)){
            const m = String(url).match(/poolballs(\d+)\.[a-zA-Z0-9]+\.png$/);
            if (m && parseInt(m[1], 10) === index) return url;
        }
    } catch (e) {
    // importmap nicht lesbar – Fallback-Farbe im Rendering greift
    }
    return null;
}
const $35da740d59af89ba$var$textureUrls = $35da740d59af89ba$var$importedUrls.map((u, i)=>{
    if (typeof u === "string") return u;
    const devUrl = $35da740d59af89ba$var$devTextureUrl(i);
    // "" verhindert einen Elm-Flag-Crash – der Load schlägt dann einfach fehl
    // und die Kugel bleibt in der Fallback-Farbe.
    return devUrl || "";
});
// Get the actual window dimensions
const $35da740d59af89ba$var$flags = {
    windowWidth: window.innerWidth,
    windowHeight: window.innerHeight,
    // Kugel-UV-Maps (index = Kugelnummer, 0 = weiße Kugel)
    textureUrls: $35da740d59af89ba$var$textureUrls
};
// Browser.document benötigt keinen DOM-Knoten – init() liefert das Dokument
// (Title + Body), das Elm selbst rendert.
(0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    flags: $35da740d59af89ba$var$flags
});


//# sourceMappingURL=repo.72ebbcd5.js.map
